// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.locations_section {
  /* background-image: url("./../../ASSETS/BACKGROUND/NoiseBgTall.webp"); 
  */
  background-color: #425151;
  background-size: cover;
  background-position: cover;
  color: #ffffff;
  padding-top: 5em;
  padding-bottom: 2em;
}
.location {
  margin: 5em;
  margin-top: 15px;
}
/* CONTAINER FOR CENTERED LOCATION + COMING SOON */
.coming-soon-wrapper {
  text-align: left;
  margin: 50px 5em;    /* same margin as others */
  padding-left: 30px;     
}
.map-placeholder{
  margin-top: 15px;
}

/* TITLE WITH YELLOW UNDERLINE UNDER WORD ONLY */
.locationTitle2 {
  font-size: 36px;
  font-weight: 500;
  color: #ffffff;
  display: inline-block;
  padding-bottom: 6px;
  border-bottom: 1px solid #FFE600;  /* underline only under text */
}

/* COMING SOON TEXT */
.coming-soon-text {
  margin-top: 8px;
  font-size: 20px;
  /* color: #FFE600; */
  color: #FFFFFF;
  opacity: 0.9;
  letter-spacing: 0.5px;
}
/* .locationTitle2::after{
   content: "";
  display: block;
  width: 120px;     
  height: 3px;
  background-color: #FFE600;
  margin: 8px auto 10px;
  padding: 10px;
} */
`, "",{"version":3,"sources":["webpack://./src/PAGES/LOCATIONS/index.css"],"names":[],"mappings":"AAAA;EACE;GACC;EACD,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA,kDAAkD;AAClD;EACE,gBAAgB;EAChB,gBAAgB,KAAK,0BAA0B;EAC/C,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC,GAAG,8BAA8B;AACnE;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,qBAAqB;AACvB;AACA;;;;;;;;GAQG","sourcesContent":[".locations_section {\n  /* background-image: url(\"./../../ASSETS/BACKGROUND/NoiseBgTall.webp\"); \n  */\n  background-color: #425151;\n  background-size: cover;\n  background-position: cover;\n  color: #ffffff;\n  padding-top: 5em;\n  padding-bottom: 2em;\n}\n.location {\n  margin: 5em;\n  margin-top: 15px;\n}\n/* CONTAINER FOR CENTERED LOCATION + COMING SOON */\n.coming-soon-wrapper {\n  text-align: left;\n  margin: 50px 5em;    /* same margin as others */\n  padding-left: 30px;     \n}\n.map-placeholder{\n  margin-top: 15px;\n}\n\n/* TITLE WITH YELLOW UNDERLINE UNDER WORD ONLY */\n.locationTitle2 {\n  font-size: 36px;\n  font-weight: 500;\n  color: #ffffff;\n  display: inline-block;\n  padding-bottom: 6px;\n  border-bottom: 1px solid #FFE600;  /* underline only under text */\n}\n\n/* COMING SOON TEXT */\n.coming-soon-text {\n  margin-top: 8px;\n  font-size: 20px;\n  /* color: #FFE600; */\n  color: #FFFFFF;\n  opacity: 0.9;\n  letter-spacing: 0.5px;\n}\n/* .locationTitle2::after{\n   content: \"\";\n  display: block;\n  width: 120px;     \n  height: 3px;\n  background-color: #FFE600;\n  margin: 8px auto 10px;\n  padding: 10px;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
